import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export function InstallAppButton({ className = "ns-button ns-button-ghost", testId = "install-app-button", label = "Install our app" }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
      setInstalled(true);
      return undefined;
    }
    const onPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    } else {
      setShowHelp(true);
      window.setTimeout(() => setShowHelp(false), 7000);
    }
  };

  return (
    <>
      <button type="button" className={className} data-testid={testId} onClick={install}><Download size={16} /> {label}</button>
      {showHelp && <p className="ns-install-hint" data-testid="install-help-hint">To install: open your browser menu and tap <strong>Add to Home Screen</strong>.</p>}
    </>
  );
}
